import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

const DeleteAvatar = async (videoId: string) => {
  const res = await axiosInstance.delete('/api/avatars/' + videoId);
  return res.data;
};

export const useDeleteAvatar = () => {
  return useMutation(DeleteAvatar, { onSuccess: (data) => data });
};
